import { moveToWithinRange } from '../moveToWithinRange/moveToWithinRange.mjs';

const returnDateView = (selectedDate, min, max) => {
  return selectedDate || (min || max) && moveToWithinRange(new Date(), min, max) || new Date();
};

export { returnDateView };
//# sourceMappingURL=getDateView.mjs.map
